import { Link } from 'react-router-dom';
import { firmInfo, navLinks, practiceAreas } from '@/mocks/firm';

export default function Footer() {
  return (
    <footer className="bg-[rgb(37,44,89)] text-background-50">
      <div className="px-4 md:px-10 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <p className="font-heading text-2xl font-semibold mb-3">{firmInfo.name}</p>
          <p className="text-sm text-background-50/80 leading-relaxed">Consejo legal personal y con principios para familias y negocios en Heredia y Costa Rica desde 2001.</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-background-50 mb-4 font-semibold">Mapa del sitio</h4>
          <ul className="space-y-2 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}><Link to={l.href} className="text-background-50/90 hover:text-background-50 cursor-pointer whitespace-nowrap">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-background-50 mb-4 font-semibold"><Link to="/about#servicios">Servicios</Link></h4>
          <ul className="space-y-2 text-sm">
            {practiceAreas.map((p) => (
              <li key={p.title}><Link to={p.href} className="text-background-50/90 hover:text-background-50 cursor-pointer">{p.title}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest text-background-50 mb-4 font-semibold">Contacto</h4>
          <ul className="space-y-3 text-sm text-background-50/90">
            <li className="flex gap-2"><i className="ri-map-pin-line text-secondary-500"></i>{firmInfo.address}</li>
            <li className="flex gap-2"><i className="ri-phone-line text-secondary-500"></i><a href={`tel:${firmInfo.phone}`}>{firmInfo.phone}</a></li>
            <li className="flex gap-2"><i className="ri-mail-line text-secondary-500"></i><a href={`mailto:${firmInfo.email}`}>{firmInfo.email}</a></li>
            <li className="flex gap-2"><i className="ri-time-line text-secondary-500"></i>{firmInfo.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-background-50/20 px-4 md:px-10 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-background-50/70">
        <p>© 2026 {firmInfo.name}. Derechos reservados.</p>
      </div>
    </footer>
  );
}